import React, { useState, useEffect } from "react";
import logo from "../../assets/imgs/navbar/logo_AMC.svg";
import newLogoPng from "../../assets/imgs/navbar/logo-amc-white.png";
import { Link } from "react-router-dom";
import "./navbar.css";
import menuIcon from "../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../assets/imgs/navbar/menu-closed.svg";
import mexIcon from "../../assets/imgs/navbar/mex_svg.svg";
import usaIcon from "../../assets/imgs/navbar/usa_svg.svg";
import { useTranslation } from "react-i18next";
import BtnSubMenu from "./btnSubMenu/btnSubMenu";
import { useNavigate } from "react-router-dom";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";

function Navbar() {
  const navigate = useNavigate();
  const [tNabvar] = useTranslation("navbar");
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("lng") || "es"
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1264);

  const handleLanguageChange = (language) => {
    localStorage.setItem("lng", language);
    if (language === "us") {
      navigate(sessionStorage.getItem("routeEn"));
    } else {
      navigate(sessionStorage.getItem("routeEs"));
    }
    window.location.reload();
  };
  const productsData = tNabvar("products-submenu", { returnObjects: true });
  const stationsData = tNabvar("stations-submenu", { returnObjects: true });
  const prepareShipmentData = tNabvar("prepare-shipment-submenu", {
    returnObjects: true,
  });
  const aboutUsData = tNabvar("about-us", { returnObjects: true });
  const closeMobileMenu = () => setClick(false);

  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      // Si cambiamos a desktop, asegurarnos de que el menú esté cerrado
      if (!mobile) {
        setClick(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // --- ESTADOS PARA EL MÓVIL ---
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Estado para controlar qué acordeones están abiertos
  // Usamos un objeto para poder tener múltiples niveles abiertos si se requiere
  const [openAccordions, setOpenAccordions] = useState({});

  const toggleAccordion = (id) => {
    setOpenAccordions(prevState => ({
      ...prevState,
      [id]: !prevState[id] // Invierte el valor (true/false) del id específico
    }));
  };

  return (
    <>
    {/* MENU TABLETS/MOBILE */}
    <div className="navbar-tablet-mobile">
      <div className="container-fluid py-3" style={{backgroundColor: '#001242'}}>
        <div className="d-flex justify-content-between align-items-center px-3">
            {/* Logo Móvil */}
          <Link to="/">
            <img src={newLogoPng} style={{height: '30px'}} alt="Aeromexico Cargo" />
          </Link>
          
          {/* Botón Hamburguesa */}
          <button className="btn-hamburger" onClick={() => setIsMobileMenuOpen(true)}>
            <HiOutlineMenuAlt2 size={24} color="white" />
          </button>
        </div>
      </div>

      {/* --- OFFCANVAS (Menú Desplegable) --- */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}>
        
        {/* Cabecera del Menú */}
        <div className="d-flex justify-content-between align-items-center p-4">
            <img src={newLogoPng} style={{height: '30px'}} alt="Logo" />
            <button className="btn-close-menu" onClick={() => setIsMobileMenuOpen(false)}>
              <HiOutlineMenuAlt2 size={24} color="white" />
            </button>
        </div>

        {/* Cuerpo del Menú */}
        <div className="mobile-menu-body">
          
          {/* GESTION DE ENVIOS */}
          <p className="mobile-menu-subtitle">GESTIÓN DE ENVÍOS</p>
          <Link to={`/${tNabvar("category-services.quote")}`} className="mobile-menu-link" onClick={() => setIsMobileMenuOpen(false)}>
            {tNabvar("principal-buttons.get-a-quote")}
          </Link>
          {/* ACORDEÓN: PREPARA TU EMBARQUE */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('prepara')}>
              <Link to="/" className="menu-text-white">{tNabvar("principal-buttons.prepare-shipment")}</Link>
              {openAccordions['prepara'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>
            <div className={`mobile-submenu ${openAccordions['prepara'] ? 'open' : ''}`}>
                <Link to={`/${tNabvar("category-services.shipments")}/restricciones`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Restricciones
                </Link>
                <Link to={`/${tNabvar("category-services.shipments")}/carga-general`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Carga General
                </Link>
                <Link to={`/${tNabvar("category-services.shipments")}/generador-de-etiquetas`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Generador de etiquetas
                </Link>
            </div>
          </div>
          <Link to={`/${tNabvar("category-services.track")}`} className="mobile-menu-link" onClick={() => setIsMobileMenuOpen(false)}>
              {tNabvar("principal-buttons.track-waybill")}
          </Link>

          {/* SERVICIOS Y ESTACIONES */}
          <p className="mobile-menu-subtitle mt-3">SERVICIOS Y ESTACIONES</p>
          {/* ACORDEÓN: SERVICIOS */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('servicios')}>
              <span>Servicios</span>
              {openAccordions['servicios'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>

            {/* Contenedor Nivel 1 */}
            <div className={`mobile-submenu ${openAccordions['servicios'] ? 'open' : ''}`}>
              
              {/* --- OPCIÓN 1: NACIONALES (Nivel 2) --- */}
              {/* Nota: Si Nacionales también tiene submenú, usamos botón toggle. Si es link directo, usa Link */}
              <div>
                  <button 
                    className="mobile-accordion-header" 
                    style={{ paddingLeft: '40px' }} // Sangría Nivel 2
                    onClick={() => toggleAccordion('nacionales')}
                  >
                    <span>Nacionales</span>
                    {openAccordions['nacionales'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                  </button>
                  
                  {/* Submenú Nacionales */}
                  <div className={`mobile-submenu ${openAccordions['nacionales'] ? 'open' : ''}`}>
                      <Link to="/servicios/nacionales/gold" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Gold</Link>
                      <Link to="/servicios/nacionales/doce+doce" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>12+12</Link>
                      <Link to="/servicios/nacionales/mensajeria" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Mensajería</Link>
                      <Link to="/servicios/nacionales/perecederos" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Perecederos</Link>
                      <Link to="/servicios/nacionales/alto-valor" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Alto Valor</Link>
                      <Link to="/servicios/nacionales/alta-tecnologia" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Alta Tecnología</Link>
                      <Link to="/servicios/nacionales/animales-vivos" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Animales Vivos</Link>
                      <Link to="/servicios/nacionales/restos-humanos" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Restos Humanos</Link>
                      <Link to="/servicios/nacionales/pharma-xps" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Pharma XPS</Link>
                      <Link to="/servicios/nacionales/pharma-std" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Pharma STD</Link>
                      <Link to="/servicios/nacionales/valija" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Valija</Link>
                      <Link to="/servicios/nacionales/mercancia-peligrosa" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Mercancía Peligrosa</Link>
                      <Link to="/servicios/nacionales/servicios-para-la-industria" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>Servicios para la industria</Link>
                  </div>
              </div>

              {/* --- OPCIÓN 2: INTERNACIONALES (Nivel 2) --- */}
              <div>
                  <button 
                    className="mobile-accordion-header" 
                    style={{ paddingLeft: '40px' }} // Sangría Nivel 2
                    onClick={() => toggleAccordion('internacionales')}
                  >
                    <span>Internacionales</span>
                    {openAccordions['internacionales'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                  </button>

                  {/* Contenedor Nivel 2 (Internacionales) */}
                  <div className={`mobile-submenu ${openAccordions['internacionales'] ? 'open' : ''}`}>
                      
                      {/* Opción A: Express */}
                      <Link to="/internacional/express" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        Express
                      </Link>

                      {/* Opción B: General */}
                      <Link to="/internacional/general" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        General
                      </Link>

                      {/* Opción: SPECIALIZED (Nivel 3 - Con Submenú) */}
                      <div>
                          <button 
                            className="mobile-accordion-header" 
                            style={{ paddingLeft: '60px' }} // Sangría Nivel 3
                            onClick={() => toggleAccordion('specialized')}
                          >
                            <span>Specialized</span>
                            {openAccordions['specialized'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                          </button>

                          {/* Contenedor Nivel 3 (Opciones de Specialized) */}
                          <div className={`mobile-submenu ${openAccordions['specialized'] ? 'open' : ''}`}>
                              <Link to="/specialized/art" className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Art</Link>
                              <Link to="/specialized/care" className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Care</Link>
                              <Link to="/specialized/dgr" className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized DGR</Link>
                              <Link to="/specialized/fresh" className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Fresh</Link>
                              <Link to="/specialized/pharma" className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Pharma</Link>
                          </div>
                      </div>
                      {/* Fin Specialized */}

                      {/* Opción: Customized */}
                      <Link to="/internacional/customizado" className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        Customized
                      </Link>

                  </div>
              </div>

              {/* --- OPCIÓN 3: ADICIONALES --- */}
              <Link to="/servicios/adicionales" className="mobile-submenu-link" style={{paddingLeft: '40px'}} onClick={() => setIsMobileMenuOpen(false)}>
                Servicios Adicionales
              </Link>

            </div>
          </div>
          {/* ACORDEÓN: ESTACIONES */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('estaciones')}>
              Estaciones
              {openAccordions['estaciones'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>
            <div className={`mobile-submenu ${openAccordions['estaciones'] ? 'open' : ''}`}>
                <Link to={`/${tNabvar("category-services.stations")}/nacionales`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Nacional
                </Link>
                <Link to={`/${tNabvar("category-services.stations")}/internacional`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Internacional
                </Link>
                <Link to={`/${tNabvar("category-services.stations")}/almacen-fiscalizado`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  Almacenes en MEX
                </Link>
            </div>
          </div>

          {/* SERVICIOS Y ESTACIONES */}
          <p className="mobile-menu-subtitle mt-3">INFORMACIÓN</p>
          <Link to="/contratos" className="menu-information-links">Contratos</Link>
          <Link to="/" className="menu-information-links">Aviso de privacidad</Link>
          <Link to="/cumplimiento-normativo" className="menu-information-links">Compliance</Link>
        </div>
      </div>
    </div>

    {/* MENU DESKTOP */}
    <div className="container-fluid navbar-redesgin navbar-desktop">
      <div className="row align-items-center">
        <div className="col d-flex justify-content-between align-items-center">
          <div className="nav-left-side">
            <Link to="/">
              <img src={newLogoPng} className="nav-logo" alt="Aeromexico Cargo" />
            </Link>
            <nav className="nav-links-main">
              <Link to={`/${tNabvar("category-services.quote")}`} className="nav-item">{tNabvar("principal-buttons.get-a-quote")}</Link>
              {/* --- INICIO MENU DESPLEGABLE --- */}
              <div className="dropdown-wrapper-2">
                <Link to="/" className="nav-item">
                    {tNabvar("principal-buttons.prepare-shipment")}
                </Link>

                <ul className="dropdown-menu-2 menu-left">
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.shipments")}/restricciones`}>Restricciones</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.shipments")}/carga-general`}>Carga General</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.shipments")}/generador-de-etiquetas`}>Generador de etiquetas</Link>
                  </li>
                </ul>
              </div>
              <Link to={`/${tNabvar("category-services.track")}`} className="nav-item">{tNabvar("principal-buttons.track-waybill")}</Link>
            </nav>
          </div>
          <div className="nav-right-side">
            <nav className="nav-links-secondary">
              {/* --- INICIO DEL DROPDOWN DE SERVICIOS --- */}
              <div className="dropdown-wrapper-2">
                <Link to="/servicios" className="nav-item">
                  Servicios
                </Link>

                {/* Nivel 1: Menú Principal (Vertical) */}
                <ul className="dropdown-menu-2">
                  
                  {/* Opción 1: Nacionales */}
                  <li className="dropdown-item has-submenu">
                    <Link to="/servicios/nacionales">Nacionales</Link>
                    <ul className="submenu-2">
                      <li><Link to="/servicios/nacionales/gold">Gold</Link></li>
                      <li><Link to="/servicios/nacionales/doce+doce">12+12</Link></li>
                      <li><Link to="/servicios/nacionales/mensajeria">Mensajería</Link></li>
                      <li><Link to="/servicios/nacionales/perecederos">Perecederos</Link></li>
                      <li><Link to="/servicios/nacionales/alto-valor">Alto Valor</Link></li>
                      <li><Link to="/servicios/nacionales/alta-tecnologia">Alta Tecnología</Link></li>
                      <li><Link to="/servicios/nacionales/animales">Animales Vivos</Link></li>
                      <li><Link to="/servicios/nacionales/restos-humanos">Restos Humanos</Link></li>
                      <li><Link to="/servicios/nacionales/pharma-xps">Pharma XPS</Link></li>
                      <li><Link to="/servicios/nacionales/pharma-std">Pharma STD</Link></li>
                      <li><Link to="/servicios/nacionales/valija">Valija</Link></li>
                      <li><Link to="/servicios/nacionales/mercancia-peligrosa">Mercancía Peligrosa</Link></li>
                      <li><Link to="/servicios/nacionales/industria">Servicios para la industria</Link></li>
                    </ul>
                  </li>

                  {/* Opción 2: Internacionales */}
                  <li className="dropdown-item has-submenu">
                    <Link to="/servicios/internacional">Internacionales</Link>
                    <ul className="submenu-2">
                      <li><Link to="/internacional/express">Express</Link></li>
                      <li><Link to="/internacional/general">General</Link></li>

                      {/* NIVEL 3 (Specialized) --- */}
                      <li className="position-relative has-submenu-level-3"> 
                        <Link to="/internacional/specialized" className="d-flex justify-content-between align-items-center">
                          Specialized
                          {/* Opcional: una flechita para indicar que hay más */}
                          <span style={{fontSize: '10px'}}>▸</span>
                        </Link>
                        <ul className="submenu-3">
                          <li><Link to="/specialized/art">Specialized Art</Link></li>
                          <li><Link to="/specialized/care">Specialized Care</Link></li>
                          <li><Link to="/specialized/dgr">Specialized DGR</Link></li>
                          <li><Link to="/specialized/fresh">Specialized Fresh</Link></li>
                          <li><Link to="/specialized/live">Specialized Live</Link></li>
                          <li><Link to="/specialized/pharma">Specialized Pharma</Link></li>
                          <li><Link to="/specialized/safe">Specialized Safe</Link></li>
                        </ul>
                      </li>
                      {/* --- FIN DEL NIVEL 3 --- */}
                      <li><Link to="/internacional/customizado">Customized</Link></li>
                    </ul>
                  </li>

                  {/* Opción 3: Servicios Adicionales */}
                  <li className="dropdown-item">
                    <Link to="/servicios/servicios-adicionales">Servicios Adicionales</Link>
                  </li>
                </ul>
              </div>
              {/* --- FIN DEL DROPDOWN --- */}
              
              {/* --- INICIO MENU DESPLEGABLE --- */}
              <div className="dropdown-wrapper-2">
                <Link to="/" className="nav-item">
                    Estaciones
                </Link>

                <ul className="dropdown-menu-2 menu-left">
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.stations")}/nacionales`}>Nacional</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.stations")}/internacional`}>Internacional</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNabvar("category-services.stations")}/almacen-fiscalizado`}>Almacenes en MEX</Link>
                  </li>
                </ul>
              </div>
            </nav>
            <div className="py-2 py-lg-0 ps-3 gap-2 d-flex justify-content-start bg-gray order-first order-lg-last">
              <button
                id="btnLangEsp"
                onClick={() => handleLanguageChange("es")}
                className={`btn-language ${
                  activeButton === "es" ? "btn-language-active" : ""
                }`}
              >
                <p>ESP</p>
                <img src={mexIcon} alt="México" />
              </button>
              <div className="btn-divider align-self-center">|</div>
              <button
                id="btnLangEng"
                onClick={() => handleLanguageChange("us")}
                className={`btn-language ${
                  activeButton === "us" ? "btn-language-active" : ""
                }`}
              >
                <p>ENG</p>
                <img src={usaIcon} alt="México" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Navbar;
